import React from "react";
import { motion } from "framer-motion";
import { Layout } from "@/components/Layout";
import { WalletPanel } from "@/components/WalletBalance";
import { Wallet, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

/**
 * WalletBalance Page
 * Provides a comprehensive interface for managing financial transactions,
 * credit limits, and balance history within ProjectViva.
 */
const WalletBalance: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <Layout>
      <div className="flex flex-col gap-2 p-4 md:p-6 w-full text-[13px] lg:text-base">
        {/* Page Header */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }}>
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <Wallet className="w-8 h-8 text-primary" />
            {t.wallet.pageTitle}
          </h1>
        </motion.div>

        {/* Main Wallet Panel */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1
      }} className="w-full">
          <WalletPanel />
        </motion.div>

        {/* Information Notice */}
        <footer className="mt-auto pt-8 border-t border-border/50 text-center">
          
          
        </footer>
      </div>
    </Layout>;
};
export default WalletBalance;